<template>
  <div id="GroupList">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Vehicle Quotes/Orders List</div>
          <router-link v-if="canAddGroup" class="btn btn-primary pull-right"
                       v-bind:to="{ path:'/vehicle-order-form/create'}"><i class="fp-add"> </i> Add
          </router-link>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content group-list">
            <data-table-filter-config :moduleName="'coPriceList'" @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'"></data-table-filter-config>
            <section class="data-table bg-white">
              <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange"
                                 :moduleName="'coPriceList'" :position="'top'">
              </custom-pagination>
              <vue-good-table ref="listCustomerOrdersTable" mode="remote" @on-page-change="onPageChange"
                              @on-selected-rows-change="selectionChanged" @on-column-filter="onColumnFilter"
                              @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange"
                              :totalRows="totalRecords" :columns="userColumns" :rows="rows" :pagination-options="{
                                      enabled: false,
                                      position: 'both',
                                      perPage: perPage,
                                      perPageDropdown:dropDownPerPage,
                                      dropdownAllowAll: false,
                                  }" :select-options="{
                                  enabled: true,
                                  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                  selectionInfoClass: 'custom-class',
                                  selectionText: 'rows selected',
                                  clearSelectionText: 'clear',
                                  }" :search-options="{
                                  enabled: false,
                                  }">

                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                  <div :key="key">
                    <div v-if="props.column.field == 'action'">
                      <a v-if="props.row.file_path != null"
                         v-on:click="goToGetDocumentPath($event, props.row)" href=""
                         target="_blank"><i class="fp-print"></i></a>
                    </div>
                    <!--
                      if the order  type is custom, then the order is an old order.
                      if the order type in In Stock and has vehicle then it is an old order.
                      for older order navigate to the order preview page and not the order create page.
                    -->
                    <div v-else-if="props.column.field === 'order_no'">
                      <template v-if="props.row.ev_customer_order_type === 'In Stock' && props.row.vehicle == null" >
                        <router-link title="View Vehicle Order" class="color-blue"
                                     v-bind:to="{name: 'CustomerOrderFormEdit',params:{id:props.row.id}}">
                          {{props.row.order_no}}
                        </router-link>
                      </template>
                      <template v-else >
                        <router-link title="View Vehicle Order" class="color-blue"
                                     v-bind:to="{name: 'CustomerOrderFormPreview',params:{id:props.row.id}}">
                          {{props.row.order_no}}
                        </router-link>
                      </template>
                    </div>
                    <div v-else-if="props.column.field == 'quote_number'">
                      <template v-if="props.row.ev_customer_order_type === 'In Stock' && props.row.vehicle == null" >
                        <router-link title="View Vehicle Order" class="color-blue"
                                     v-bind:to="{name: 'CustomerOrderFormEdit',params:{id:props.row.id}}">
                          {{props.row.quote_number}}
                        </router-link>
                      </template>
                      <template v-else >
                        <router-link title="View Vehicle Order" class="color-blue"
                                     v-bind:to="{name: 'CustomerOrderFormPreview',params:{id:props.row.id}}">
                          {{props.row.quote_number}}
                        </router-link>
                      </template>
                    </div>
                    <div v-else-if="props.column.field == 'vehicle_option_code'">
                      <span
                        class="popover-dismiss"
                        role="button"
                        tabindex="0"
                        data-container="body"
                        data-toggle="popover"
                        data-trigger="focus"
                        data-placement="right"
                        :data-content="`${props.row.vehicle_option_code} - ${props.row.vehicle_option_description}`"
                        style="cursor: pointer"
                      >
                        {{ props.row.vehicle_option_code }}
                      </span>
                    </div>
                    <div v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </div>
                  </div>
                </template>

                <div slot="selected-row-actions">
                  <button id="PlaceOrderBtn" v-on:click.prevent="placeOrder"
                          class="btn btn-primary">Place Order
                  </button>
                  <button v-if="canMapVehicle" id="addAssetBtn" v-on:click.prevent="openModal()"
                          class="btn btn-primary">Map Vehicle
                  </button>
                </div>
              </vue-good-table>
              <custom-pagination :page-changed="onPageChange" :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
          <div class="modal fade policy-modal" id="item-modal" ref="item-modal" data-backdrop="static"
               data-keyboard="false" aria-labelledby="item-modal" aria-hidden="true">
            <div class="modal-dialog" role="document" style="max-width: 1000px;">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Map VIN to Vehicle Order</h5>
                </div>
                <div class="modal-body">
                  <section class="internal-container border-top-table-fl">
                    <form autocomplete="off"
                          class="form-horizontal basic-form-container form-custom-select"
                          id="VehicleInformationForm">
                      <div class="form-row">
                        <div class="form-group col-12">
                          <label class="control-label require" for="vehicle_id">VIN:</label>
                          <v-select v-model="vehicle_id" id="vehicle_id" name="vehicle_id"
                                    label="text" :filterable="false" :options="vehicleArr"
                                    @search="onSearchAsset" @change="onVinChange"
                                    placeholder="Search VIN"
                                    class='custom-ci-auto-search close-remove'>
                            <template slot="no-options">
                              Search VIN...
                            </template>
                            <template slot="option" slot-scope="option">
                              <div class="d-center">
                                {{ option.text }}
                              </div>
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              <div class="selected d-center">
                                {{ option.text }}
                              </div>
                            </template>
                          </v-select>
                          <div class="field-error">{{ vehicle_error_msg }}</div>
                        </div>
                      </div>
                      <div class="from-group">
                        <div class="alert alert-warning hide offset-sm-2 col-sm-6"
                             id="alertError">
                          <button type="button" class="close" data-dismiss="alert"
                                  aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <strong id="errorMsg" class="field-error"></strong>
                        </div>
                      </div>
                    </form>
                  </section>

                  <div id="asset-detail" class="admin-page-content asset-view list-view" v-if="vehicleId != ''">
                    <section class="internal-container border-top-table-fl">
                      <h2>Vehicle Information</h2>
                      <div class="form-row no-divider">
                        <div class="col-md-6">
                          <div class="row form-group">
                            <label class="col">Name :</label>
                            <span class="col">{{ titleCase(assetData.name) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">VIN :</label>
                            <span class="col">{{ titleCase(assetData.vin) }}</span>
                          </div>

                          <div class="row form-group">
                            <label class="col">Wheelbase :</label>
                            <span class="col">{{ assetData.wheelbase }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Paint {{ color_spelling }} :</label>
                            <span class="col">{{ assetData.color_ext }}</span>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row form-group">
                            <label class="col">#Unit :</label>
                            <span class="col" v-show="!addAddressFlag">{{ titleCase(assetData.unit_no) }}</span>
                            <div class="col">
                              <input type="text" id="edit_unit" name="edit_unit" placeholder="Enter Unit"
                                     v-if="addAddressFlag" class="col" v-model="assetData.unit_no">
                              <div class="field-error" v-if="addAddressFlag && unit_error != null">{{
                                  unit_error
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="row form-group">
                            <label class="col">Status :</label>
                            <span class="col"
                                  v-if="(velocity_env == 'velev' || velocity_env == 'velev_test') && assetData.vsName == 'In Garage'">In
                                                            Progress</span>
                            <span class="col" v-else>{{ titleCase(assetData.vsName) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Model :</label>
                            <span class="col">{{ titleCase(assetData.vmodelsName) }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Marketability :</label>
                            <span class="col">{{ assetData.marketability }}</span>
                          </div>
                          <div class="row form-group">
                            <label class="col">Battery Size</label>
                            <span class="col">{{ assetData.batterySize }}</span>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>

                  <div class="modal-footer">
                    <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"><i
                      class="fp-close"> </i>Cancel
                    </button>
                    <button class="btn btn-primary" id="importButton" v-on:click="mapVehicle()"><i
                      class="fp-import"> </i> Map Vehicle
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div v-if="showPurchaseOrderModal" class="modal fade" id="purchaseOrder" tabindex="-1" role="dialog"
             aria-labelledby="purchaseOrderLabel" data-backdrop="static">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div style="display: flex; justify-content: center; align-items: center;" class="mt-4 mb-3">
                <img :src="logoPath" alt="Dealer Pro" style="height: 70px; margin-right: 7px">
              </div>
              <div class="pl-5 pr-5 mt-1">
                <p>To convert this quote into an order please update the following</p>
                <div class="form-row">
                  <div class="col-12 form-group">
                    <div class="d-flex justify-content-between">
                      <label class="control-label require" for="purchase_order_no">Please enter a valid purchase order
                        number</label>
                      <span style="font-size: 14px;">{{ purchase_order_no_count }}/50</span>
                    </div>
                    <input type="text" class="form-control" v-model.trim="purchase_order_no"
                           id="purchase_order_no" placeholder="Purchase Order#" name="purchase_order_no">
                    <span class="field-error">{{ purchase_order_no_error_msg }}</span>
                  </div>
                </div>
                <DropZone ref="modalDropzoneComponentRef" :uniqueRef="'modalDropzoneInstance'"
                          :showDropzone="true"
                          :showUploadedFiles="dropZonePreviewFiles && dropZonePreviewFiles.length > 0"
                          :maxFileLimit='5' :docErrorMsg="doc_error_msg"
                          :dropZonePreviewFiles="dropZonePreviewFiles"
                          :acceptedFiles="'.jpg, .jpeg, .png, .pdf, .docx, .doc'"
                          :fileSizeLimit="10"
                          :mainDivCol="'col-md-12'"
                          :dropzoneRequired="false"
                          :dropzoneLabel="'Please attach a copy of purchase order'"
                          :dropzoneCol="'col-12'" :dropzoneFilesCol="'col-12'"
                          :noteBelowDropzone="noteForDropZone"
                          :canRemoveUploadedFiles="false"
                          @dropzone-update-files="updateFiles"/>
              </div>
              <div class="d-flex justify-content-around mt-4 mb-3">
                <button type="button"
                        id="purchaseOrderSubmitBtn" @click="checkPurchaseOrder()" class="btn-lg btn-primary"
                        style="width: 150px;">Place Order
                </button>
                <button type="button" @click="closePurchaseOrderModal()" class="btn-lg btn-primary"
                        style="width: 150px;">Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
import EventBus from "../event-bus";

Vue.component("loading-content", LoadingContent);

import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';

Vue.use(VueGoodTable);

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

import DropZone from '../DropZone.vue';

export default {
  name: "CustomerOrderList",
  components: {
    DropZone,
    customPagination: () => import('@/components/layout/CustomPagination'),
    dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
    appFooter: () => import('@/components/Footer'),
  },
  metaInfo() {
    return {title: "Vehicle Orders List | " + process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,dataTableMixins],
  data: () => ({
      firstLoad: 0,
        permissions: [],
      cantAccessPage: "",
      userColumns:[],
      velocity_env:process.env.NODE_ENV,
      columns: [
          {
              label: 'Actions',
              field: 'action',
              sortable: false,
              hidden:false,
          },
          {
              label: 'Order Number',
              field: 'order_no',
              filterable: true,
              fpFieldType:"text",
              hidden:false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Order Number", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Quote Number',
              field: 'quote_number',
              filterable: true,
              fpFieldType:"text",
              hidden:false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Quote Number", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Purchase Order#',
              field: 'purchase_order_no',
              filterable: true,
              fpFieldType:"text",
              hidden:false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Purchase Order#", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Order Type',
              field: 'ev_customer_order_type',
              filterable: true,
              hidden:false,
              fpFieldType:"option",
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Order Type", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Order Status',
              field: 'status',
              filterable: true,
              fpFieldType:"option",
              hidden:false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Order Status", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  filterDropdownItems: ['O', 'Q'],
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
            label: 'Quote Expired',
            field: 'is_expired',
            fpFieldType: "option",
            filterable: true,
            hidden: false,
            filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Quote Expired", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Yes', 'No'],
              trigger: "enter" //only trigger on enter not on keyup
            }
          },
        {
          label: 'Created Date',
          field: 'created_at',
          filterable: true,
          fpFieldType:"date",
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "MM/DD/YYYY", // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
          {
              label: 'Order Date',
              field: 'order_date',
              filterable: true,
              fpFieldType:"date",
              hidden:false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "MM/DD/YYYY", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Customer Name',
              field: 'customer_name',
              filterable: true,
              fpFieldType:"text",
              hidden:false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Customer Name", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Dealer Code',
              field: 'dealer_code',
              filterable: true,
              fpFieldType:"text",
              hidden:false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Dealer Code", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Dealer Name',
              field: 'dealer_name',
              filterable: true,
              fpFieldType:"text",
              hidden:false,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Dealer Name", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Class',
              field: 'class',
              filterable: true,
              hidden:false,
              fpFieldType:"option",
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Class", // placeholder for filter input
                  filterDropdownItems: ['e16', 'e18'],
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Battery Size',
              field: 'battery_size',
              filterable: true,
              hidden:false,
              fpFieldType:"option",
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Battery Size", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Wheelbase',
              field: 'wheelbase',
              filterable: true,
              hidden:false,
              fpFieldType:"option",
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Wheelbase", // placeholder for filter input
                filterDropdownItems: [
                  'L175',
                  'L187',
                  'M134',
                  'M152',
                  'M175',
                  'M187',
                  '175',
                  '187',
                  '134',
                  '152',
                ],
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Option Code',
              field: 'vehicle_option_code',
              filterable: true,
              hidden:false,
              fpFieldType:"option",
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "vehicle Option Code", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Delivery Area',
              field: 'delivery_area',
              filterable: true,
              hidden:false,
              fpFieldType:"option",
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Delivery Area", // placeholder for filter input
                  filterDropdownItems: ["Dealer’s Transporter", "Southern CA", "Northern CA", "NY/NJ", "TX", "NE", "OR/WA"],
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Color',
              field: 'color',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Color", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'VIN',
              field: 'vehicle',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Vehicle", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
        {
          label: 'Vehicle Status',
          field: 'vehicle_status',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Vehicle Status", // placeholder for filter input
            filterDropdownItems: [],
            trigger: "enter" //only trigger on enter not on keyup
          }
        },
          {
              label: 'Vehicle Price',
              field: 'vehicle_price',
              filterable: true,
              hidden:false,
              fpFieldType:"integer",
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Vehicle Price", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          // {
          //     label: 'Extended Warranty Price',
          //     field: 'extended_warranty_price',
          //     filterable: true,
          //     hidden:false,
          //     fpFieldType:"integer",
          //     filterOptions: {
          //         enabled: false, // enable filter for this column
          //         placeholder: "Extended Warranty Price", // placeholder for filter input
          //         filterValue: '', // initial populated value for this filter
          //         trigger: "enter" //only trigger on enter not on keyup
          //     }
          // },
          {
              label: 'Delivery Fee',
              field: 'delivery_fee',
              filterable: true,
              hidden:false,
              fpFieldType:"integer",
              filterOptions: {
                  enabled: false, // enable filter for this
                  placeholder: "Delivery Fee", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
          {
              label: 'Ordered By',
              field: 'ordered_by',
              filterable: true,
              hidden:false,
              fpFieldType:"text",
              filterOptions: {
                  enabled: false, // enable filter for this
                  placeholder: "Ordered By", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
      ],
      rows: [],
      totalRecords: 0,
      group_value: false,
      loading:false,
      canUpdateGroup:false,
      canAddGroup:false,
      canMapVehicle: false,
      canDeleteOrder: false,
      vehicle_id: "",
      vehicle_error_msg: "",
      vehicleArr: [],
      assetData: [],
      vehicleId: "",
      addAddressFlag: false,
      logoPath: '',
      purchase_order_no: '',
      purchase_order_no_error_msg: '',
      purchase_order_no_count: 0,
      doc_error_msg: '',
      files: [],
      showPurchaseOrderModal: false,
      dropZonePreviewFiles: [],
  }),
  created: function () {
    this.logoPath = process.env.LOGO_PATH;
  },
  computed: {
    dropzoneId() {
      return 'dropzone-' + Math.random().toString(36).substr(2, 9);
    },
    noteForDropZone(){
      if(this.dropZonePreviewFiles.length > 0){
        return "Uploaded Files Will Be Overridden If New Files Are Uploaded!";
      }else{
        return null;
      }
    }
  },
  watch: {
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (self.velocity_env == 'velev' || self.velocity_env == 'velev_test') {
            if (permissions[i].name == 'ev_list_vehicle_order') {
              self.cantAccessPage = true;
            }
            if (permissions[i].name == 'ev_delete_vehicle_order') {
              self.canDeleteOrder = true;
            }
            if (permissions[i].name == 'ev_add_vehicle_order') {
              ``
              self.canAddGroup = true;
              self.canUpdateGroup = true;
            }
            if (permissions[i].name == 'ev_map_custom_vehicle_order') {
              self.canMapVehicle = true;
            }
          } else {
            if (permissions[i].name == 'list_customer_order_price') {
              self.cantAccessPage = true;
            }
            if (permissions[i].name == 'delete_customer_order_price') {
              self.group_value = true;
            }
            if (permissions[i].name == 'add_customer_order_price') {
              self.canAddGroup = true;
              self.canUpdateGroup = true;
            }
          }
        }
      }

    },
    purchase_order_no(newValue) {
      if (newValue.length > 50) {
        this.purchase_order_no = newValue.substring(0, 50);
      }
      this.purchase_order_no_count = newValue.length;
    },
  },
  updated() {
    this.initializePopovers();
  },
  mounted: function () {
    var self = this;

    self.getPermissions();
    self.loadList();
    self.$nextTick(() => {
      self.initializePopovers();

      const colorColumn = self.columns.find(col => col.field === 'color');
      if (colorColumn) {
          colorColumn.label = self.color_spelling;
      }
    });
  },
  methods: {
    updateFiles(files) {
        this.files = files;
    },
    initializePopovers() {
      this.$nextTick(() => {
        // destroy any existing popovers first (optional, but avoids duplicates)
        $('.popover-dismiss').popover('dispose');
        // re-initialize with focus trigger
        $('.popover-dismiss').popover({
          trigger: 'focus'
        });
      });
    },
    cancelAll: function (cancelAll) {
      this.$refs.listCustomerOrdersTable.unselectAllInternal();
    },
    selectionChanged(param) {
      var self = this;
      if (param.selectedRows.length == 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
    },
    loadList() {
      var self = this;
      self.loading = true;
      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        sort: self.serverParams.sort,
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/customer-orders/list",
        type: "POST",
        data: fields,
        headers: {
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          "Access-Control-Allow-Headers":
            "Origin, Content-Type, Authorization,X-Requested-With",
          "Cache-Control": "no-cache"
        },
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status == "success") {
            self.rows = data.content.row;
            self.totalRecords = data.content.totalRecords;
            self.filteredFlag = false;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'customer-order-price-list')
        }
      });
    },
    addAsset: function (flag) {
      var self = this;
      var data = self.$refs['listCustomerOrdersTable'].selectedRows;
      var use = [];
      for (var i = 0; i < data.length; i++) {
        if (data[i].ev_customer_order_type != 'Custom') {
          self.$swal('', 'Please Select Only Custom Order', 'info');
          return;
        }
        if (data[i].vehicle != null) {
          self.$swal('', 'Please Select Custom Order Without Asset', 'info');
          return;
        }
        if (data[i].order_no == null) {
          self.$swal('', 'Please Select Custom Order which has been placed!', 'info');
          return;
        }
        use.push(this.$refs['listCustomerOrdersTable'].selectedRows[i].id)
      }
      if (use.length > 1) {
        self.$swal('', 'Please Select Atmost One Order', 'info');
        return;
      }
      if (flag == 'asset') {
        self.$router.push("/available-vehicles/list?from=custom_order&order=" + use[0]);
      }
    },
    PriceDelete() {
      var self = this;
      self.$swal({
        title: 'Are you sure that you want to delete this customer order?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          var data = this.$refs['listCustomerOrdersTable'].selectedRows;
          var use = [];
          for (var i = 0; i < data.length; i++) {
            use.push(this.$refs['listCustomerOrdersTable'].selectedRows[i].id)
          }
          self.loading = true;
          $("#deleteGroupBtn").val("Deleting ...");
          $.ajax({
            url: process.env.ROOT_API + "/customer-order/delete",
            type: "POST",
            data: 'id=' + use,
            headers: {
              'Accept': 'application/json',
              "Access-Control-Allow-Origin": '*',
              "Authorization": "Bearer " + localStorage.getItem("tkn"),
              'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
              "Cache-Control": "no-cache"
            },
            dataType: 'json',
            success: function (data) {
              self.loading = false;
              setTimeout(function () {
                $(".alert-success").removeClass("show");
                $(".alert-success").addClass("hide");
              }, 10000);
              setTimeout(function () {
                $("#deleteGroupBtn").val("Delete");
              }, 10000);
              self.rows = data.content.row;
              if (data.code == '200') {
                self.rows = data.content.row;
                self.totalRecords = data.content.totalRecords;
                self.loadList();
              }
            },
            error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR, true, 'group-delete')
            }
          });

        } else {
          console.log("no");
        }
      });
    },
    isValidURL(url) {
      return /^https?:\/\//.test(url);
    },
    placeOrder() {
      var self = this;
      var data = this.$refs['listCustomerOrdersTable'].selectedRows;
      if (data.length > 1) {
        self.$swal('', 'Cannot place an order for multiple quotes at once. Please select only one quote to proceed.!', 'warning');
        return;
      }
      self.$swal({
        title: 'Are you sure you want to place the order?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          var use = [];
          let invalid = false;
          var vins = [];
          for (var i = 0; i < data.length; i++) {
            if (
              data[i].order_no != null
              &&
              data[i].status == "O"
            ) {
              self.$swal('', 'Please select orders which have not been placed already!', 'info');
              invalid = true;
              return;
            }
            if(
              data[i].is_expired == "Yes"
            ){
              self.$swal('', 'The Selected Quote is expired! Please select a quote which is not expired!', 'info');
              invalid = true;
              return;
            }
            if (data[i].vehicle != null && data[i].vehicle != '') {
              if (vins.includes(data[i].vehicle)) {
                self.$swal('', 'Please select only one order per VIN number!', 'info');
                return;
              } else {
                vins.push(data[i].vehicle);
              }
            }
            if (
              data[i].order_no == null
              &&
              data[i].status == "Q"
              &&
              data[i].quote_number != null
              &&
              data[i].quote_number != ''
            ) {
              self.showPurchaseOrderModal = true;
              self.$nextTick(() => {
                self.dropZonePreviewFiles = data[i].doc_file_path;
                if(self.dropZonePreviewFiles == null || self.dropZonePreviewFiles === "" ){
                  self.dropZonePreviewFiles = [];
                }
                self.purchase_order_no = data[i].purchase_order_no
                $('#purchaseOrder').modal('show');
              });
              return;
            }

            use.push(this.$refs['listCustomerOrdersTable'].selectedRows[i].id)
          }
          // if(!invalid){
          self.placeOrderForQuotedOrder(use);
          // }

        } else {
          console.log("no");
        }
      });
    },
    placeOrderForQuotedOrder(use) {
      var self = this;
      self.loading = true;
      $("#PlaceOrderBtn").val("Placing Order ...");
      $("#purchaseOrderSubmitBtn").val("Placing Order ...");

      $.ajax({
        url: process.env.ROOT_API + "/convert-quote-to-order",
        type: "POST",
        data: {
          orderIds: use,
          purchaseOrderNo: self.purchase_order_no,
          purchaseOrderFiles: self.files
        },
        headers: {
          'Accept': 'application/json',
          "Access-Control-Allow-Origin": '*',
          "Authorization": "Bearer " + localStorage.getItem("tkn"),
          'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
          "Cache-Control": "no-cache"
        },
        dataType: 'json',
        success: function (data) {
          self.loading = false;
          self.closePurchaseOrderModal();
          self.loadList();
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'group-delete')
        }
      });
    },
    checkPurchaseOrder() {
      this.purchase_order_no_error_msg = '';
      var success = true;

      if (
        this.purchase_order_no == ''
        ||
        this.purchase_order_no == null
      ) {
        this.purchase_order_no_error_msg = 'Purchase order# is required.';
        success = false;
      }

      if (success) {
        const selectedRows = this.$refs['listCustomerOrdersTable'].selectedRows;
        const ids = selectedRows.map(row => row.id);
        this.placeOrderForQuotedOrder(ids);
      } else {
        this.errorValidationFocus();
      }
    },
    goToGetDocumentPath(event, row) {
      event.preventDefault();
      var self = this;
      var path = row.file_path;
      var flag = '';
      var id = 0;

      self.getDocumentPath(id, path, flag);
    },
    onVinChange(newValue) {
      if (newValue == null || newValue == '') {
        this.vehicle_id = '';
        this.vehicleArr = [];
        this.assetData = [];
        this.vehicleId = "";
        this.vehicle_error_msg = "";
      } else {
        this.loadVehicleDetails(this.vehicle_id.value);
      }
    },
    onSearchAsset(search, loading) {
      loading(true);
      this.searchField(loading, search, 'available_vehicles');
    },
    openModal: function () {
      var self = this;
      var selectedrows = self.$refs['listCustomerOrdersTable'].selectedRows;
      if (selectedrows.length == 1) {
        if (selectedrows[0].ev_customer_order_type == "In Stock") {
          this.$swal('', 'Please select a custom vehicle order', 'warning');
          return;
        }
        if (selectedrows[0].order_no == '' || selectedrows[0].order_no == null) {
          this.$swal('', 'Order has not been placed for this record! Please place an order first!', 'warning');
          return;
        }
        if (selectedrows[0].vehicle != null) {
          this.$swal('', 'Vehicle has already been mapped to this custom vehicle order!', 'warning');
          return;
        }
        this.vehicle_id = '';
        this.vehicleArr = [];
        this.assetData = [];
        this.vehicleId = "";
        this.vehicle_error_msg = "";
        $('#item-modal').modal('show');
      } else {
        this.$swal('', 'Cannot Map Multiple vehicle orders', 'warning');
        return;
      }

    },
    loadVehicleDetails(id) {
      var self = this;
      this.vehicle_error_msg = '';
      if (id != null && id != '' && id > 0) {
        self.vehicleId = id;
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/asset/" + self.vehicleId,
          type: "GET",
          headers: this.ajxHeaders,
          data: {
            action_flag: 'view', // pass action for notify: view, edit
            is_notify_flag: true // notify if user viewing or editing
          },
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (data.status == "success") {
              self.assetData = data.content;
              self.checkIfSelectedVehicleValidOrNot();
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            self.generateStatusCodeMessage(jqXHR, true, 'asset-load-view')

          }
        });
      } else {
        this.vehicle_error_msg = "Please select the vehicle to get the details!";
      }

    },
    mapVehicle: function () {
      var self = this;

      var use = [];
      use.push(self.vehicleId)
      var order = self.$refs['listCustomerOrdersTable'].selectedRows[0].id;
      var fields = [];

      fields.push({name: 'vehicles', value: JSON.stringify(use)});
      fields.push({name: 'order_id', value: order});

      if (confirm('Are you sure that you want to map this vehicle to this vehicle order? ')) {
        self.loading = true;
        $.ajax({
          url: process.env.ROOT_API + "/order-asset/add",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: 'json',
          success: function (data) {
            self.loading = false;
            setTimeout(function () {
              $(".alert-success").removeClass("show");
              $(".alert-success").addClass("hide");
            }, 10000);

            if (data.code == '200') {
              $('#item-modal').modal('hide');
              self.$swal({
                title: "",
                text: "Vehicle Mapped Successfully",
                type: "success",
                showCancelButton: true,
                confirmButtonText: "Ok",
                cancelButtonText: "Cancel",
                showCloseButton: true,
                showLoaderOnConfirm: true
              }).then(result => {
                self.loadList();
              });

            }

            if (data.code == '201') {
              self.$swal({
                title: "",
                text: data.message,
                type: "error",
                showCancelButton: false,
                confirmButtonText: "Ok",
                showCloseButton: true,
                showLoaderOnConfirm: true
              }).then(result => {
                return;
              });
            }
          },
          error: function (jqXHR, exception) {
            self.loading = false;
            if (jqXHR.status == 0) {
              self.error = "Remote server cannot be reached";
            } else {
              //redirect to login page if user not authenticated
              if (jqXHR.status == 401) {
                //clear previous data
                localStorage.removeItem('user_obj');
                localStorage.removeItem('tkn');

                self.$router.push("/");
              }
              self.error = jqXHR.responseJSON.message;
            }
          }
        });
      }
    },
    checkIfSelectedVehicleValidOrNot() {

      var selectedOrder = this.$refs['listCustomerOrdersTable'].selectedRows[0];
      var orderWheelbase = selectedOrder.wheelbase;

      if (selectedOrder.color == "Natural White (W31)") {
        var orderColor = "White";
      } else {
        var orderColor = selectedOrder.color;
      }

      var wheelbaseMatch = this.assetData.wheelbase == orderWheelbase.slice(1);
      var batterySizeMatch = this.assetData.batterySize == selectedOrder.battery_size;
      var colorMatch = this.assetData.color_ext.toLowerCase() == orderColor.toLowerCase();
      var classMatch = this.assetData.vmodelsName == selectedOrder.class;

      const checks = [
        {
          match: colorMatch,
          message: this.color_spelling+' in Order: ' + orderColor + ' | ' + this.color_spelling +' of Vehicle: ' + this.assetData.color_ext
        },
        {
          match: classMatch,
          message: 'Class in Order: ' + selectedOrder.class + ' | ' + 'Class of Vehicle: ' + this.assetData.vmodelsName
        },
        {
          match: wheelbaseMatch,
          message: 'Wheelbase in Order: ' + orderWheelbase.slice(1) + ' | ' + 'Wheelbase of Vehicle: ' + this.assetData.wheelbase
        },
        {
          match: batterySizeMatch,
          message: 'Battery Size in Order: ' + selectedOrder.battery_size + ' | ' + 'Battery Size of Vehicle: ' + this.assetData.batterySize
        }
      ];

      let allMatch = true;
      var misMatchInfo = '<h4 style="font-weight: bold;">' + 'Cannot map VIN ' + this.assetData.vin + ', the following properties are not matching!' + '</h4>' + "<ul>";

      checks.forEach(check => {
        if (!check.match) {
          allMatch = false;
          misMatchInfo = misMatchInfo + '<li style="text-align: left;">' + check.message + '</li>';
        }
      });
      misMatchInfo = misMatchInfo + '</ul><p style="color: red; text-align: center">Please select VIN with relevant details!</p>';


      if (!allMatch) {
        this.$swal({
          title: '',
          html: misMatchInfo,
          icon: 'warning'
        });
        this.vehicle_id = "";
      }
    },
    closePurchaseOrderModal() {
      if (
          this.$refs.modalDropzoneComponentRef
          &&
          this.$refs.modalDropzoneComponentRef.$refs.modalDropzoneInstance
      ) {
        this.$refs.modalDropzoneComponentRef.$refs.modalDropzoneInstance.removeAllFiles(true);
        this.$refs.modalDropzoneComponentRef.$refs.modalDropzoneInstance.destroy();
      }
      this.purchase_order_no_count = 0;
      this.purchase_order_no = '';
      this.purchase_order_no_error_msg = '';
      this.doc_error_msg = '';
      this.files = [];
      this.showPurchaseOrderModal = false;

      $('#purchaseOrder').modal('hide');
    },
  }
};
</script>
<style scoped>
.loader-vvg {
  z-index: 1063;
}
</style>



// WEBPACK FOOTER //
// src/components/asset/CustomerOrderList.vue